let sessionExpiredHandler = null;
/**
 * Register a callback invoked when the session expires (e.g. after a failed
 * 401 refresh). Consumer apps use this to show a "session expired" dialog.
 */
export function setSessionExpiredHandler(fn) {
    sessionExpiredHandler = fn;
}
/**
 * Trigger the session expired handler. Called internally by the API client
 * when token refresh fails.
 */
export function notifySessionExpired() {
    if (sessionExpiredHandler)
        sessionExpiredHandler();
}
//# sourceMappingURL=session.js.map